import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useIntl, FormattedMessage } from 'react-intl';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import TSTable from '@ts-core/components/Table/TSTable';

const GroupStudentsTable = (props) => {
  const {
    students,
    groupName,
    onAddStudents,
    addStudentsEnabled,
    loading,
  } = props;
  const intl = useIntl();
  const columns = useMemo(() => {
    return [
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.name' }),
        value: intl.formatMessage({ id: 'studentsTable.column.name' }),
        accessor: 'name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.email' }),
        value: intl.formatMessage({ id: 'studentsTable.column.email' }),
        accessor: 'email',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        value: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        accessor: 'personalId',
        sortable: true,
      },
    ];
  }, [intl]);

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6">{groupName}</Typography>
        <Button onClick={onAddStudents} disabled={!addStudentsEnabled}>
          <FormattedMessage id="groupsDetails.addStudents" />
        </Button>
      </Box>
      <TSTable
        loading={loading}
        title=""
        data={students}
        columns={columns}
        emptyMessage={
          loading ? null : <FormattedMessage id="groupDetails.noStudents" />
        }
      />
    </>
  );
};

GroupStudentsTable.propTypes = {
  students: PropTypes.array.isRequired,
  groupName: PropTypes.string,
  addStudentsEnabled: PropTypes.bool.isRequired,

  loading: PropTypes.bool.isRequired,

  onAddStudents: PropTypes.func.isRequired,
};

GroupStudentsTable.defaultProps = {
  groupName: '',
};

export default GroupStudentsTable;
